"use client";

import { c as _c } from "react/compiler-runtime";
import { LocaleName } from "@/app/i18n/settings";
import { AdvertiserLocation, AdvertiserLocationWithCompany } from "@/types/location";
import { useTranslation } from "@/app/i18n/client";
import { createCompanyURI } from "@/components/Util/AdvertiserHelpers";
import Image from "next/image";
import Link from "next/link";
import { getGoogleMapsLinkWithAddress } from "@/utils/Utils";
import { Company } from "@/types/company";
export default function AdvertiserDetailList(t0) {
  const $ = _c(7);
  const {
    advertisers,
    lng
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["advertiser"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== lng) {
    t2 = {
      lng
    };
    $[1] = lng;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    t
  } = useTranslation(t1, t2);
  let t3;
  if ($[3] !== advertisers || $[4] !== lng || $[5] !== t) {
    const advertiserWithAllLocationsMap = new Map();
    advertisers?.forEach(adv => {
      if (advertiserWithAllLocationsMap.has(adv.company.id)) {
        const currentEntry = advertiserWithAllLocationsMap.get(adv.company.id);
        currentEntry[1].push(adv.advertiserLocation);
        advertiserWithAllLocationsMap.set(adv.company.id, currentEntry);
      } else {
        advertiserWithAllLocationsMap.set(adv.company.id, [adv.company, [adv.advertiserLocation]]);
      }
    });
    const advertiserList = Array.from(advertiserWithAllLocationsMap).map(t4 => {
      const [, advertiser] = t4;
      const url = createCompanyURI(advertiser[0], lng);
      return <div key={advertiser[0].id} className="flex flex-col border-0 border-b border-solid last:border-0"><div><h2 className="mb-0 text-left">{advertiser[0].publicData.companyName}</h2></div><div className="flex flex-col items-center lg:flex-row"><div className="lg:basis-2/5"><Image alt="teaser" width={300} height={150} src={advertiser[0].startpageInfo?.teaserPicture ?? ""} className="h-auto w-full max-w-[300px] object-contain" /></div><div className="p-4 lg:basis-3/5"><p className="text-lg font-bold">{advertiser[0].startpageInfo?.title}</p><p>{advertiser[0].startpageInfo?.description}</p><h3>{t("advertiser:ADVERTISER.LOCATIONS", {
                count: advertiser[1].length
              })}</h3><ul>{advertiser[1].map((advloc, i) => <li key={advertiser[0].id + i}><a href={getGoogleMapsLinkWithAddress(advloc.address.address)}>{advloc.address.address}</a></li>)}</ul><div className="flex flex-row justify-end"><Link href={url} className="button matchbus">{t("advertiser:MODAL.PROFILE_BUTTON")}</Link></div></div></div></div>;
    });
    t3 = <div className="flex flex-col">{advertiserList}</div>;
    $[3] = advertisers;
    $[4] = lng;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}